var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.072,27.036V6.3q0-.036.108-.684l12.2,10.44L.216,27.756a3.051,3.051,0,0,1-.144-.72Zm1.62-22.86A1.551,1.551,0,0,1,2.3,4.068H35.172a2.039,2.039,0,0,1,.648.108L23.58,14.652l-1.62,1.3-3.2,2.628-3.2-2.628-1.62-1.3ZM1.728,29.16,14,17.388l4.752,3.852,4.752-3.852L35.784,29.16a1.729,1.729,0,0,1-.612.108H2.3a1.631,1.631,0,0,1-.576-.108Zm23.4-13.1L37.3,5.616A2.149,2.149,0,0,1,37.4,6.3V27.036a2.759,2.759,0,0,1-.108.72Z","transform":"translate(-0.072 -4.068)"}));
}

Email.defaultProps = {"width":"37.332","height":"25.199","viewBox":"0 0 37.332 25.199"};

module.exports = Email;

Email.default = Email;
